<template>
  <el-form ref="waterForm" :model="waterForm" :rules="waterRules" label-width="110px">
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="设备型号" prop="deviceModel">
          <el-input
            v-if="!isDetail()"
            v-model="waterForm.deviceModel"
            maxlength="50"
            placeholder="请输入"
          ></el-input>
          <span v-else>{{ waterForm.deviceModel || '-' }}</span>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="出厂编号" prop="factoryNo">
          <el-input
            v-if="!isDetail()"
            v-model="waterForm.factoryNo"
            maxlength="50"
            placeholder="请输入"
          ></el-input>
          <span v-else>{{ waterForm.factoryNo || '-' }}</span>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="设备状态" prop="status">
          <el-select v-if="!isDetail()" v-model="waterForm.status" style="width: 100%">
            <el-option
              v-for="item in typeList"
              :key="item.type"
              :label="item.typeName"
              :value="item.type"
            ></el-option>
          </el-select>
          <span v-else>{{ typeObj[waterForm.status] || '-' }}</span>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>
<script>
export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: Object
    }
  },
  data() {
    return {
      typeList: [
        { type: 0, typeName: '启用' },
        { type: 1, typeName: '停用' }
      ],
      typeObj: {
        0: '启用',
        1: '停用'
      },
      waterForm: {}
    };
  },
  inject: ['isDetail'],

  watch: {
    value: {
      immediate: true,
      deep: true,
      handler: function (newVal) {
        this.waterForm = newVal;
      }
    },
    waterForm: {
      immediate: true,
      deep: true,
      handler: function (newVal) {
        this.$emit('change', newVal);
      }
    }
  },
  computed: {
    waterRules() {
      return {
        status: [{ required: !this.isDetail(), message: '请选择设备状态', trigger: 'change' }]
      };
    }
  },
  methods: {
    getNationNo() {
      // getNationNum().then(res => {
      //   if (!res.success) {
      //     return;
      //   }
      //   this.waterForm.mnNum = res.data
      // });
    },
    getData() {
      let data = {
        deviceModel: this.waterForm.deviceModel,
        factoryNo: this.waterForm.factoryNo,
        status: this.waterForm.status
      };
      return data;
    },
    setData(data) {
      const { deviceModel, factoryNo, status } = data;
      this.waterForm.deviceModel = deviceModel;
      this.waterForm.factoryNo = factoryNo;
      this.waterForm.status = status;
    },
    reset() {
      this.$refs.waterForm.resetFields();
    },
    validate() {
      let type;
      this.$refs.waterForm.validate(validated => {
        type = validated;
      });
      return type;
    }
  }
};
</script>
